export const TRACKABLE_ORG_ID = `00000000-0000-0000-0000-000000000000`

/**
 * True while operating inside the Trackable (internal) organization. Used to lock
 * internal-only actions out of client orgs.
 *
 * Deliberately a plain comparison, unlike `isSMCOrg`: that helper's `IS_SMC_ORG` /
 * `TESTING` short-circuits return `true`, which here would leak a destructive action
 * rather than merely widen a view.
 *
 * Note `user.orgId` is the org context currently switched into, not a fixed home org —
 * `setOrg` re-authenticates and reloads — so this follows the org selector.
 */
export function isTrackableOrg(orgId: string | undefined): boolean {
  return orgId === TRACKABLE_ORG_ID
}
